<template>
  <VBlock class="empty-wrap" :direction="Direction.column">
    <VBlock class="empty-box" :direction="Direction.column">
      <VBlock
        class="empty-image-box"
        :style="{ width: `${isMinimumSize ? 200 : 240}px`, height: `${isMinimumSize ? 200 : 240}px`, marginBottom: `${isMinimumSize ? 15 : 30}px`  }"
      >
        <img
          class="empty-image"
          :src="resources.EmptyImage"
          :width="isMinimumSize ? 200 : 240"
          :height="isMinimumSize ? 200 : 240"
        />
      </VBlock>
      <p class="empty-message" :style="{ fontSize: '14px' }">B마트 주문내역이 없어요</p>
      <VBlock v-if="hasBmartIcon && isSign" :margin="[15, 0, 0, 0]">
        <VButton
          :class="['bmart-button', isMinimumSize ? 'small-padding-button' : 'max-padding-button']"
          :radius="30"
          :onClick="moveToBmart"
        >
          <VSpan text="B마트 주문하러가기" :spacing="-0.35" :size="fontSize" />
        </VButton>
      </VBlock>
    </VBlock>
    <VBlock
      v-show="!isSign && isUpdate"
      class="text-wrapper"
      :direction="Direction.column"
      :padding="[20, 16, 20, 16]"
    >
      <!-- <hr class="div-line" /> -->
      <div class="div-line"></div>
      <p
        class="non-member-message"
        :style="{ fontSize: `${fontSize}px` }"
      >비회원의 주문내역은 30일 동안 확인 가능합니다. 배달의민족 앱을 삭제하시면 비회원 주문내역을 확인할 수 없습니다</p>
      <p
        class="non-member-message"
        v-show="!isUpdate"
        :style="{ fontSize: `${fontSize}px` }"
      >{{ appVersion }} 버전 이전에서 주문한 '배민마켓 주문' 항목은 ‘배달•테이크아웃 주문’에서 확인하실 수 있습니다.</p>
    </VBlock>
  </VBlock>
</template>

<script>
import VBlock, { Direction, Sort } from '../../molecules/VBlock'
import VButton from '../../atoms/VButton'
import VSpan, { TextType, TextColor, TextWeight } from '../../atoms/VSpan'

import EmptyImage from '@/assets/images/b@2x.png'

export default {
  name: 'EmptyOrders',
  components: { VBlock, VButton, VSpan },
  props: {
    isUpdate: {
      type: Boolean,
      default: true
    },
    hasBmartIcon: {
      type: Boolean,
      default: false
    },
    appVersion: {
      type: String,
      default: ''
    },
    isSign: {
      type: Boolean,
      default: false
    },
    moveToBmart: {
      type: Function,
      required: true
    }
  },
  computed: {
    fontSize() {
      return 11
    },
    isMinimumSize() {
      return window.innerHeight <= 510
    }
  },
  data() {
    return {
      Direction,
      TextType,
      TextColor,
      TextWeight,
      Sort,

      resources: {
        EmptyImage
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.empty-wrap {
  width: 100vw;
  height: 100vh;
  position: relative;

  .empty-box {
    .empty-image-box {
      margin-top: -42px;
    }

    .empty-message {
      color: $gray;
      font-size: 16px;
    }

    .bmart-button {
      background-color: $white;
      border: 1px solid $light-gray-4;
    }

    .max-padding-button {
      padding: 17px 20px 16px 20px;
    }

    .small-padding-button {
      padding: 12px 14px 11px 14px;
    }
  }

  .text-wrapper {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);

    .div-line {
      width: 100%;
      margin-bottom: 20px;
      border-top: 1px solid $light-gray-5;
      background-color: $light-gray-8;
    }

    .non-member-message {
      font-size: 14px;
      text-align: center;
      color: $gray-3;
      text-align: center;
    }
  }
}
</style>
